import cx from "classnames";
import { forwardRef, RefObject } from "react";

import Box from "ds/components/Box";

import useHorizontalScrollDetection from "../hooks/useHorizontalScrollDetection";
import styles from "./styles.module.css";

export type TableWrapperProps = {
  children: React.ReactNode;
  hasPagination?: boolean;
  bottomOffset?: number;
  className?: string;
};

const TableWrapper = forwardRef<HTMLDivElement, TableWrapperProps>(
  ({ children, hasPagination = true, bottomOffset, className }, ref) => {
    const scrollPosition = useHorizontalScrollDetection(ref as RefObject<HTMLDivElement | null>);

    return (
      <Box
        ref={ref}
        className={cx(styles.tableWrapper, { [styles.hasPagination]: hasPagination }, className)}
        data-scroll-at-start={scrollPosition.isAtStart}
        data-scroll-at-end={scrollPosition.isAtEnd}
        style={{ paddingBottom: bottomOffset }}
        direction="column"
      >
        {children}
      </Box>
    );
  }
);

TableWrapper.displayName = "DS.Table.Wrapper";
export default TableWrapper;
